import Pickup from '@/components/Pickup';

const Size = () => import(/* webpackChunkName: "components-Size" */'@/components/Size');
const Shipping = () => import(/* webpackChunkName: "components-Shipping" */'@/components/Shipping');
const Delivery = () => import(/* webpackChunkName: "components-Delivery" */'@/components/Delivery');
const Continue = () => import(/* webpackChunkName: "components-Continue" */'@/components/Continue');
const Quote = () => import(/* webpackChunkName: "components-Quote" */'@/components/Quote');
const QuoteName = () => import(/* webpackChunkName: "components-QuoteName" */'@/components/QuoteName');
const QuoteEmail = () => import(/* webpackChunkName: "components-QuoteEmail" */'@/components/QuoteEmail');
const QuotePhone = () => import(/* webpackChunkName: "components-QuotePhone" */'@/components/QuotePhone');
const QuoteTextVerify = () => import(/* webpackChunkName: "components-QuoteTextVerify" */'@/components/QuoteTextVerify');
const Auto = () => import(/* webpackChunkName: "components-Auto" */'@/components/Auto');
const Thanks = () => import(/* webpackChunkName: "components-Thanks" */'@/components/Thanks');
const NotFound = () => import(/* webpackChunkName: "components-NotFound" */'@/components/NotFound');

export default [
	{
		path: '/secure',
		name: 'home',
		component: Pickup,
		meta: {
			analytics: {
				pageName: 'Landing',
			},
		},
	},
	{
		path: '/secure',
		name: 'Pickup',
		component: Pickup,
		meta: {
			analytics: {
				pageName: 'Landing',
			},
		},
	},
	{
		path: '/size',
		name: 'Size',
		component: Size,
		meta: {
			analytics: {
				pageName: 'Move_size',
			},
		},
	},
	{
		path: '/shipping',
		name: 'Shipping',
		component: Shipping,
		meta: {
			analytics: {
				pageName: 'Shipping',
			},
		},
	},
	{
		path: '/delivery',
		name: 'Delivery',
		component: Delivery,
		meta: {
			analytics: {
				pageName: 'Destination',
			},
		},
	},
	{
		path: '/continue',
		name: 'Continue',
		component: Continue,
	},
	{
		path: '/quote',
		name: 'Quote',
		component: Quote,
		alias: '/quote/name',
		children: [
			{
				path: 'name',
				name: 'Quote-Name',
				component: QuoteName,
				meta: {
					analytics: {
						pageName: 'Name',
					},
					pageClass: 'quote-info',
					validateFields: ['firstName', 'lastName'],
				},
			},
			{
				path: 'email',
				name: 'Quote-Email',
				component: QuoteEmail,
				meta: {
					analytics: {
						pageName: 'Email',
					},
					pageClass: 'quote-info',
					validateFields: ['email'],
				},
			},
			{
				path: 'phone',
				name: 'Quote-Phone',
				component: QuotePhone,
				meta: {
					analytics: {
						pageName: 'Phone',
					},
					pageClass: 'quote-info',
					validateFields: ['phone'],
				},
			},
			{
				path: 'verify',
				name: 'Quote-Text-Verify',
				component: QuoteTextVerify,
				meta: {
					analytics: {
						pageName: 'Text_verify',
					},
				},
			},
		],
	},
	{
		path: '/auto',
		name: 'Auto',
		component: Auto,
		meta: {
			analytics: {
				pageName: 'Auto_interest',
			},
		},
	},
	{
		path: '/thank-you',
		name: 'Thank-You',
		component: Thanks,
		meta: {
			analytics: {
				pageName: 'Thank_You',
			},
		},
	},
	{
		path: '*',
		name: 'notfound',
		component: NotFound,
	},
];
